import { render, staticRenderFns } from "./BaseStandardModal.vue?vue&type=template&id=753a9b6f&scoped=true&"
import script from "./BaseStandardModal.vue?vue&type=script&lang=ts&"
export * from "./BaseStandardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a9b6f",
  null
  
)

export default component.exports